import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error('Missing Supabase URL or Anon Key. Please check environment variables.');
}

// Keep one auth client during Vite refreshes. Separate clients can compete to
// refresh the same persisted session; a browser restart restores it via the SDK.
const createSupabaseClient = () => createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        flowType: 'pkce'
    }
});

export const supabase = (import.meta.hot?.data.supabase as ReturnType<typeof createSupabaseClient> | undefined) ?? createSupabaseClient();

if (import.meta.hot) import.meta.hot.dispose(data => { data.supabase = supabase; });
